import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { translateText, getEffectiveLang } from "@/lib/i18n";

const ATTRS = ["placeholder", "title", "aria-label"];

const translateEl = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n;
  while ((n = walker.nextNode())) {
    const t = translateText(n.nodeValue);
    if (t !== n.nodeValue) n.nodeValue = t;
  }
  if (root.querySelectorAll) {
    const sel = ATTRS.map((a) => `[${a}]`).join(",");
    const els = [...root.querySelectorAll(sel)];
    if (root.matches && root.matches(sel)) els.push(root);
    els.forEach((el) =>
      ATTRS.forEach((a) => {
        const v = el.getAttribute(a);
        if (v) {
          const t = translateText(v);
          if (t !== v) el.setAttribute(a, t);
        }
      })
    );
  }
};

export const Translator = () => {
  const { user } = useAuth();
  const active = getEffectiveLang(user) === "en";

  useEffect(() => {
    if (!active) return;
    document.documentElement.lang = "en";
    translateEl(document.body);
    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "characterData") {
          const t = translateText(m.target.nodeValue);
          if (t !== m.target.nodeValue) m.target.nodeValue = t;
        } else if (m.type === "attributes" && m.target.getAttribute) {
          const v = m.target.getAttribute(m.attributeName);
          if (v) {
            const t = translateText(v);
            if (t !== v) m.target.setAttribute(m.attributeName, t);
          }
        } else {
          m.addedNodes.forEach((node) => {
            if (node.nodeType === 3) {
              const t = translateText(node.nodeValue);
              if (t !== node.nodeValue) node.nodeValue = t;
            } else if (node.nodeType === 1) {
              translateEl(node);
            }
          });
        }
      }
    });
    obs.observe(document.body, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ATTRS,
    });
    return () => {
      obs.disconnect();
      document.documentElement.lang = "es";
    };
  }, [active]);

  return null;
};
